import { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import VolverAContactarEnUnRenglon, { avisarDesdeParaPlazo } from './VolverAContactarEnUnRenglon';
import { agregarAVolverAContactar, mensajeDeError } from '../../services/volverAContactarService';
import { apellidoNombre } from '../../utils/nombrePersona';
import { formatearTipoTramite } from '../../constants/tiposTramiteTurno';

/**
 * Agregar una atención ya finalizada al listado "Volver a contactar" (desde el histórico de turnos).
 *
 * Arriba muestra el motivo de no avance y su detalle: es lo que el operador mira para decidir si
 * vale la pena volver a contactarlo. Modal de Bootstrap con el tamaño por defecto y `scrollable`.
 */
export default function ModalAgregarVolverAContactar({ show, turno, onCerrar, onAgregado }) {
    const [meses, setMeses] = useState(0);
    const [guardando, setGuardando] = useState(false);
    const [error, setError] = useState('');

    // Se limpia cada vez que se abre: depende de `show` y del turno, no de objetos del render.
    useEffect(() => {
        if (!show) return;
        setMeses(0);
        setError('');
    }, [show, turno?.idTurno]);

    const agregar = async () => {
        if (!turno?.idTurno) return;
        setGuardando(true);
        setError('');
        try {
            const registro = await agregarAVolverAContactar({ idTurno: turno.idTurno, avisarDesde: avisarDesdeParaPlazo(meses) });
            onAgregado?.(registro);
        } catch (e) {
            setError(mensajeDeError(e, 'No se pudo agregar al listado.'));
        } finally {
            setGuardando(false);
        }
    };

    const fechaTurno = turno?.fechaTurno
        ? new Date(`${turno.fechaTurno}T00:00:00`).toLocaleDateString('es-AR')
        : '';

    return (
        <Modal show={show} onHide={guardando ? undefined : onCerrar} scrollable centered>
            <Modal.Header closeButton={!guardando}>
                <Modal.Title style={{ fontSize: '1.1rem' }}>
                    <i className="bi bi-telephone-outbound me-2" />Volver a contactar
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {turno && (
                    <div className="mb-3 p-2 rounded" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                        <div style={{ fontWeight: 600, color: '#1e293b' }}>{apellidoNombre(turno.apellido, turno.nombre)}</div>
                        <div className="small text-muted">
                            {formatearTipoTramite(turno.tipoTramite)}{fechaTurno && ` · ${fechaTurno}`}
                            {turno.telefonoCliente ? ` · ${turno.telefonoCliente}` : ' · sin teléfono'}
                        </div>
                        {turno.motivoNoAvance && (
                            <div className="mt-1 small"><strong>{turno.motivoNoAvance}</strong></div>
                        )}
                        {turno.observacionMotivoNoAvance && (
                            <div className="small" style={{ color: '#475569' }}>{turno.observacionMotivoNoAvance}</div>
                        )}
                    </div>
                )}
                {turno && !turno.telefonoCliente && (
                    <div className="alert alert-warning py-2 small">
                        El turno no tiene teléfono: va a quedar en el listado, pero no se le va a poder mandar el aviso hasta cargarlo.
                    </div>
                )}
                <VolverAContactarEnUnRenglon conCasilla={false} meses={meses} onMeses={setMeses} idPrefijo="vac-historico" />
                {error && <div className="alert alert-danger py-2 small mt-3 mb-0">{error}</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onCerrar} disabled={guardando}>Cancelar</Button>
                <Button variant="primary" onClick={agregar} disabled={guardando}>
                    {guardando ? <Spinner animation="border" size="sm" className="me-2" /> : <i className="bi bi-plus-lg me-2" />}
                    Agregar al listado
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
